import Vue from 'vue'
import VueRouter from 'vue-router'
import Bear from '../views/Bear.vue'
import Noise from '../views/Noise.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Bear',
    component: Bear
  },
  {
    path: '/noise',
    name: 'Noise',
    component: Noise
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
